import React from "react";
import { StyleSheet, View, Text } from "react-native";
import { COLOR } from "../../styles/Colors";
import { TEXT } from "../../styles/Text";

const VerifiedTag = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.captionText}>Verified</Text>
    </View>
  );
};

export default VerifiedTag;

const styles = StyleSheet.create({
  container: {
    borderRadius: 50,
    borderWidth: 1,
    borderColor: COLOR.GREEN,
    paddingHorizontal: 8,
    paddingVertical: 2,
    alignItems: "center",
    justifyContent: "center",
  },
  captionText: {
    ...TEXT.caption1,
    color: COLOR.GREEN,
  },
});
